module.exports = __webpack_public_path__ + "img/bg_function01_1_m.7c8c7f6a.png";